import axios from 'axios'
import store from '@/store'
import router from '@/router'

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Si il y a un token ET qu'on est pas sur l'appel authenticate
  if (config.url.indexOf('login') === -1 && store.state.auth.token) {
    config.headers['Authorization'] = 'Bearer ' + store.state.auth.token
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

let refreshPromise = null
let refreshing = false

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  if (response && response.headers && response.headers.token) {
    store.commit('TOKEN', response.headers.token)
  }
  return response
}, function (error) {
  if (error.response && error.response.status === 401) {
    if (error.config.url.indexOf('refresh') === -1) {
      if (refreshing) {
        // mise en attente de la request...
        return refreshPromise.then(() => {
          return axios(error.config)
        })
      } else {
        refreshing = true
        // on tente un refresh token
        refreshPromise = new Promise(function (resolve, reject) {
          axios.post('/api/v1/refresh')
            .then(() => {
              return axios(error.config)
                .then(() => resolve())
                .catch((err) => reject(err))
            })
            .catch((err) => {
              reject(new Error(err))
              router.push({ name: 'login' })
            })
            .finally(() => {
              refreshing = false
            })
        })
        return refreshPromise
      }
    }
  }
  return Promise.reject(error)
})
